import { UseCase, UseCaseId } from "@/(global)/contact/components/types";
import type { Locale } from "@/config/i18n";
import { tr } from "@/config/localeText";
import { CONTACT_UI } from "@/(global)/contact/components/contactDict";

type UseCaseSelectorProps = {
  selected: UseCaseId;
  useCases: UseCase[];
  onPickUseCase: (id: UseCaseId) => void;
  locale?: Locale;
};

export const UseCaseSelector = ({
  selected,
  useCases,
  onPickUseCase,
  locale = "fr",
}: UseCaseSelectorProps): JSX.Element => {
  const t = tr(CONTACT_UI, locale).selector;
  return (
    <div className="rounded-2xl border border-primary/30 bg-gradient-to-b from-primary/10 to-white p-4 ring-1 ring-primary/15">
      <p className="mb-2 inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-2 py-0.5 text-[10px] uppercase tracking-[0.25em] text-primary">
        {t.step}
      </p>
      <p className="mb-2 text-sm font-semibold tracking-wide text-black">
        {t.heading}
      </p>
      <p className="mb-3 text-xs text-black/60">{t.help}</p>
      <div className="grid gap-2">
        {useCases.map((uc) => (
          <button
            key={uc.id}
            type="button"
            onClick={() => onPickUseCase(uc.id)}
            className={`rounded-xl border px-3 py-3 text-start transition-all ${
              selected === uc.id
                ? "border-primary/50 bg-primary/10"
                : "border-black/10 bg-white hover:border-primary/40"
            }`}
          >
            <div className="text-sm font-semibold">{uc.label}</div>
            <div className="text-xs text-black/65">{uc.subtitle}</div>
          </button>
        ))}
      </div>
    </div>
  );
};
